// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17g4-","left":"styles_left__1ecGC","desktopActions":"styles_desktopActions__1brQ1","title":"styles_title__2rS_9"};